function SvgComponent(props: any) {

    return (
        <svg
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
        <path
            d="M16.2 2.2a1.4 1.4 0 011.4 1.4v16.8a1.4 1.4 0 01-1.4 1.4H7.8a1.4 1.4 0 01-1.4-1.4V3.6a1.4 1.4 0 011.4-1.4h8.4zM7.8.8A2.8 2.8 0 005 3.6v16.8a2.8 2.8 0 002.8 2.8h8.4a2.8 2.8 0 002.8-2.8V3.6A2.8 2.8 0 0016.2.8H7.8z"
            fill={props.isSelected ? "#5627FF" : "#000"}
        />
        <path d="M12 20.4a1.4 1.4 0 100-2.8 1.4 1.4 0 000 2.8z" fill={props.isSelected ? "#5627FF" : "#000"} />
        </svg>
    )
}
  
  export default SvgComponent